export const headphones = () => (
  <path
    d="M3 18v-6a9 9 0 1118 0v6m0 1a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3v5zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3v5z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
